import { atom } from "recoil";

export const createTgBotsRotationState = () => ({
	show: false,
	loaded: false,
	saving: false,
	enabled: false,
	botIds: [],
	intervalDays: "14",
	nextRotationAt: null,
	eligibleBots: [],
	error: {
		text: "",
		code: 0,
		timestamp: 0,
	},
});

export const tgBotsRotationStore = atom({
	key: "tgBotsRotationStore",
	default: createTgBotsRotationState(),
});
